import { createContext, useContext, type ReactNode } from "react";

/**
 * Lets the shared chat rail show a document preview under a CreateArtifact row
 * without knowing workshop artifacts. The workshop chat supplies the card;
 * everywhere else nothing renders.
 */
export type CreatedArtifactRef = {
  id: string;
  title: string | null;
};

export type CreatedArtifactCardRenderer = (artifact: CreatedArtifactRef) => ReactNode;

export const CreatedArtifactCardContext = createContext<CreatedArtifactCardRenderer | null>(
  null,
);

export function useCreatedArtifactCard() {
  return useContext(CreatedArtifactCardContext);
}

export const CREATE_ARTIFACT_TOOL = "CreateArtifact";

/** The artifact a CreateArtifact call produced, read off its tool result. */
export function createdArtifactRef(event: {
  toolName: string;
  result?: unknown;
}): CreatedArtifactRef | null {
  if (event.toolName !== CREATE_ARTIFACT_TOOL) return null;
  const result = event.result;
  if (!result || typeof result !== "object" || !("artifactId" in result)) return null;
  const id = String((result as { artifactId: unknown }).artifactId ?? "");
  if (!id) return null;
  const title =
    "title" in result ? String((result as { title: unknown }).title ?? "") : "";
  return { id, title: title || null };
}
